import { h } from "preact";

interface DiscoverIconProps {
  opacity?: number;
}

const DiscoverIcon = ({ opacity = 1 }: DiscoverIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    fill="none"
    viewBox="0 0 40 26"
    opacity={opacity}
  >
    <path fill="#fff" d="M0 0h40v26H0z" />
    <g clip-path="url(#a)">
      <g clip-path="url(#b)">
        <path
          fill="#000"
          d="M3.5 19.56a1.6 1.6 0 0 1 1.54-1.6h.06a1.52 1.52 0 0 1 1.42.77l-.43.25a1.02 1.02 0 0 0-.99-.59 1.13 1.13 0 0 0-1.14 1.11v.03a1.05 1.05 0 0 0 .99 1.14h.1a.94.94 0 0 0 1.04-.83H5.01v-.43h1.51v1.66h-.46v-.49l.03-.12a1.08 1.08 0 0 1-1.08.64 1.49 1.49 0 0 1-1.51-1.48v-.06Zm3.58-1.79h.46v3.33h-.46v-3.33Zm.92 2.2a1.2 1.2 0 1 1 .74 1.11A1.19 1.19 0 0 1 8 19.96Zm1.91 0a.74.74 0 1 0-1.48.06.72.72 0 0 0 .74.7.74.74 0 0 0 .74-.77Zm1.36.8v.33h-.46v-3.36h.46v1.4a.98.98 0 0 1 .77-.38 1.19 1.19 0 0 1 0 2.38.9.9 0 0 1-.77-.37Zm1.48-.8a.75.75 0 1 0-1.5-.04v.03a.76.76 0 1 0 1.5 0Zm.8.55c0-.46.28-.65.9-.74.43-.06.58-.1.58-.25s-.12-.37-.46-.37a.54.54 0 0 0-.58.43l-.44-.18a1.01 1.01 0 0 1 1.02-.65c.59 0 .96.3.96.86v1.48h-.43v-.33a.75.75 0 0 1-.74.4c-.5 0-.8-.28-.8-.65Zm1.33.06a.5.5 0 0 0 .19-.4v-.19c0 .1-.16.13-.5.16-.4.06-.55.15-.55.34 0 .15.15.28.37.28.18 0 .35-.07.49-.19Zm1.14-2.8h.46v3.32h-.46v-3.33Zm2.04.24h.5l1.53 2.34v-2.34h.47v3.12h-.47l-1.57-2.41v2.4h-.46v-3.11Zm2.96 1.94a1.18 1.18 0 0 1 1.17-1.2h.03a1.14 1.14 0 0 1 1.17 1.11v.25h-1.94a.77.77 0 0 0 .96.58c.2-.05.37-.17.49-.34l.37.22a1.18 1.18 0 0 1-1.05.56 1.15 1.15 0 0 1-1.2-1.11v-.07Zm.46-.21h1.45a.67.67 0 0 0-.7-.56.7.7 0 0 0-.75.56Zm2.56.61v-1.14h-.46v-.4h.46v-.5l.46-.3v.8h.62v.4h-.65v1.14c0 .25.13.37.31.37.12 0 .24-.03.34-.09v.43a.82.82 0 0 1-.37.1c-.46 0-.71-.25-.71-.8Zm1.36-1.54h.46l.52 1.67.62-1.67h.43l.62 1.67.55-1.67h.47l-.8 2.28h-.44l-.61-1.66-.65 1.7h-.46l-.71-2.32Zm3.88 1.14a1.2 1.2 0 1 1 .74 1.12 1.19 1.19 0 0 1-.74-1.12Zm1.92 0a.74.74 0 1 0-1.48.07.72.72 0 0 0 .74.7.74.74 0 0 0 .74-.77Zm.89-1.14h.46v.4a.72.72 0 0 1 .65-.4h.19v.46h-.28c-.37 0-.56.16-.56.6v1.22h-.46v-2.28Zm2.59 1.24-.4.43v.58h-.46v-3.3h.46V20l1.08-1.17h.55l-.89.96.92 1.32h-.52l-.74-1.04ZM5.2 10.16H3.72v5.18H5.2c.66.03 1.32-.18 1.85-.59a2.56 2.56 0 0 0 .92-1.97c0-1.54-1.14-2.62-2.77-2.62Zm1.2 3.88c-.3.28-.74.4-1.39.4h-.28v-3.39h.28a1.88 1.88 0 0 1 1.39.43 1.73 1.73 0 0 1 .55 1.3c0 .48-.2.93-.55 1.26Zm2.03-3.88h1.02v5.18H8.43v-5.18Zm3.49 2c-.62-.22-.77-.37-.77-.65 0-.34.3-.58.74-.58a.97.97 0 0 1 .8.43l.53-.68a2.32 2.32 0 0 0-1.52-.59 1.52 1.52 0 0 0-1.6 1.42v.06c0 .71.34 1.08 1.26 1.42.25.08.49.18.71.31a.64.64 0 0 1 .31.53.75.75 0 0 1-.74.74h-.03a1.29 1.29 0 0 1-1.1-.68l-.66.61a2 2 0 0 0 1.8 1 1.68 1.68 0 0 0 1.78-1.7c-.03-.87-.37-1.24-1.51-1.64Zm1.82.59a2.66 2.66 0 0 0 2.65 2.68h.06c.44 0 .88-.1 1.27-.3v-1.18a1.54 1.54 0 0 1-1.2.55 1.69 1.69 0 0 1-1.73-1.63v-.15a1.72 1.72 0 0 1 1.66-1.8h.03a1.64 1.64 0 0 1 1.27.6v-1.15c-.38-.2-.8-.31-1.23-.3a2.69 2.69 0 0 0-2.78 2.68Zm11.97.9-1.4-3.5h-1.07l2.19 5.31h.52l2.25-5.3h-1.1l-1.4 3.48Zm2.96 1.69h2.83v-.87h-1.85v-1.41h1.8v-.87h-1.8v-1.14h1.85v-.9h-2.83v5.19Zm6.84-3.64c0-.96-.68-1.51-1.82-1.51h-1.48v5.18h1.02v-2.1h.12l1.4 2.07h1.23l-1.64-2.2a1.36 1.36 0 0 0 1.17-1.44Zm-2.03.86h-.31V11h.3c.62 0 .96.28.96.77.03.52-.3.8-.95.8Zm2.84-2.13c0-.09-.07-.15-.19-.15h-.15v.46h.12v-.15l.12.18h.13l-.13-.21c.06 0 .1-.06.1-.13Zm-.19.07-.03-.13h.03c.06 0 .1.03.1.06-.04.07-.07.07-.1.07Z"
        />
      </g>
      <path
        fill="#000"
        d="M36.16 10.13a.4.4 0 0 0-.4.4.4.4 0 1 0 .8 0 .4.4 0 0 0-.4-.4Zm0 .74a.32.32 0 0 1-.34-.31.32.32 0 0 1 .65-.03.34.34 0 0 1-.3.34Z"
      />
      <path
        fill="url(#c)"
        d="M18.06 12.75a2.75 2.75 0 1 0 5.49 0 2.75 2.75 0 0 0-5.5 0Z"
      />
      <path
        fill="url(#d)"
        d="M18.06 12.75a2.75 2.75 0 1 0 5.49 0 2.75 2.75 0 0 0-5.5 0Z"
      />
      <mask
        id="e"
        width="6"
        height="6"
        x="18"
        y="10"
        maskUnits="userSpaceOnUse"
        style="mask-type:luminance"
      >
        <path
          fill="#fff"
          d="M18.06 12.75a2.74 2.74 0 1 0 5.49 0 2.74 2.74 0 0 0-5.5 0Z"
        />
      </mask>
      <g mask="url(#e)">
        <path
          fill="url(#f)"
          d="M17.75 12.87a3.36 3.36 0 1 0 6.72 0 3.36 3.36 0 0 0-6.72 0Z"
        />
      </g>
    </g>
    <g clip-path="url(#g)">
      <g clip-path="url(#h)">
        <path
          fill="#000"
          d="M3.5 19.56a1.6 1.6 0 0 1 1.54-1.6h.06a1.52 1.52 0 0 1 1.42.77l-.43.25a1.02 1.02 0 0 0-.99-.59 1.13 1.13 0 0 0-1.14 1.11v.03a1.05 1.05 0 0 0 .99 1.14h.1a.94.94 0 0 0 1.04-.83H5.01v-.43h1.51v1.66h-.46v-.49l.03-.12a1.08 1.08 0 0 1-1.08.64 1.49 1.49 0 0 1-1.51-1.48v-.06Zm3.58-1.79h.46v3.33h-.46v-3.33Zm.92 2.2a1.2 1.2 0 1 1 .74 1.11A1.19 1.19 0 0 1 8 19.96Zm1.91 0a.74.74 0 1 0-1.48.06.72.72 0 0 0 .74.7.74.74 0 0 0 .74-.77Zm1.36.8v.33h-.46v-3.36h.46v1.4a.98.98 0 0 1 .77-.38 1.19 1.19 0 0 1 0 2.38.9.9 0 0 1-.77-.37Zm1.48-.8a.75.75 0 1 0-1.5-.04v.03a.76.76 0 1 0 1.5 0Zm.8.55c0-.46.28-.65.9-.74.43-.06.58-.1.58-.25s-.12-.37-.46-.37a.54.54 0 0 0-.58.43l-.44-.18a1.01 1.01 0 0 1 1.02-.65c.59 0 .96.3.96.86v1.48h-.43v-.33a.75.75 0 0 1-.74.4c-.5 0-.8-.28-.8-.65Zm1.33.06a.5.5 0 0 0 .19-.4v-.19c0 .1-.16.13-.5.16-.4.06-.55.15-.55.34 0 .15.15.28.37.28.18 0 .35-.07.49-.19Zm1.14-2.8h.46v3.32h-.46v-3.33Zm2.04.24h.5l1.53 2.34v-2.34h.47v3.12h-.47l-1.57-2.41v2.4h-.46v-3.11Zm2.96 1.94a1.18 1.18 0 0 1 1.17-1.2h.03a1.14 1.14 0 0 1 1.17 1.11v.25h-1.94a.77.77 0 0 0 .96.58c.2-.05.37-.17.49-.34l.37.22a1.18 1.18 0 0 1-1.05.56 1.15 1.15 0 0 1-1.2-1.11v-.07Zm.46-.21h1.45a.67.67 0 0 0-.7-.56.7.7 0 0 0-.75.56Zm2.56.61v-1.14h-.46v-.4h.46v-.5l.46-.3v.8h.62v.4h-.65v1.14c0 .25.13.37.31.37.12 0 .24-.03.34-.09v.43a.82.82 0 0 1-.37.1c-.46 0-.71-.25-.71-.8Zm1.36-1.54h.46l.52 1.67.62-1.67h.43l.62 1.67.55-1.67h.47l-.8 2.28h-.44l-.61-1.66-.65 1.7h-.46l-.71-2.32Zm3.88 1.14a1.2 1.2 0 1 1 .74 1.12 1.19 1.19 0 0 1-.74-1.12Zm1.92 0a.74.74 0 1 0-1.48.07.72.72 0 0 0 .74.7.74.74 0 0 0 .74-.77Zm.89-1.14h.46v.4a.72.72 0 0 1 .65-.4h.19v.46h-.28c-.37 0-.56.16-.56.6v1.22h-.46v-2.28Zm2.59 1.24-.4.43v.58h-.46v-3.3h.46V20l1.08-1.17h.55l-.89.96.92 1.32h-.52l-.74-1.04ZM5.2 10.16H3.72v5.18H5.2c.66.03 1.32-.18 1.85-.59a2.56 2.56 0 0 0 .92-1.97c0-1.54-1.14-2.62-2.77-2.62Zm1.2 3.88c-.3.28-.74.4-1.39.4h-.28v-3.39h.28a1.88 1.88 0 0 1 1.39.43 1.73 1.73 0 0 1 .55 1.3c0 .48-.2.93-.55 1.26Zm2.03-3.88h1.02v5.18H8.43v-5.18Zm3.49 2c-.62-.22-.77-.37-.77-.65 0-.34.3-.58.74-.58a.97.97 0 0 1 .8.43l.53-.68a2.32 2.32 0 0 0-1.52-.59 1.52 1.52 0 0 0-1.6 1.42v.06c0 .71.34 1.08 1.26 1.42.25.08.49.18.71.31a.64.64 0 0 1 .31.53.75.75 0 0 1-.74.74h-.03a1.29 1.29 0 0 1-1.1-.68l-.66.61a2 2 0 0 0 1.8 1 1.68 1.68 0 0 0 1.78-1.7c-.03-.87-.37-1.24-1.51-1.64Zm1.82.59a2.66 2.66 0 0 0 2.65 2.68h.06c.44 0 .88-.1 1.27-.3v-1.18a1.54 1.54 0 0 1-1.2.55 1.69 1.69 0 0 1-1.73-1.63v-.15a1.72 1.72 0 0 1 1.66-1.8h.03a1.64 1.64 0 0 1 1.27.6v-1.15c-.38-.2-.8-.31-1.23-.3a2.69 2.69 0 0 0-2.78 2.68Zm11.97.9-1.4-3.5h-1.07l2.19 5.31h.52l2.25-5.3h-1.1l-1.4 3.48Zm2.96 1.69h2.83v-.87h-1.85v-1.41h1.8v-.87h-1.8v-1.14h1.85v-.9h-2.83v5.19Zm6.84-3.64c0-.96-.68-1.51-1.82-1.51h-1.48v5.18h1.02v-2.1h.12l1.4 2.07h1.23l-1.64-2.2a1.36 1.36 0 0 0 1.17-1.44Zm-2.03.86h-.31V11h.3c.62 0 .96.28.96.77.03.52-.3.8-.95.8Zm2.84-2.13c0-.09-.07-.15-.19-.15h-.15v.46h.12v-.15l.12.18h.13l-.13-.21c.06 0 .1-.06.1-.13Zm-.19.07-.03-.13h.03c.06 0 .1.03.1.06-.04.07-.07.07-.1.07Z"
        />
      </g>
      <path
        fill="#000"
        d="M36.16 10.13a.4.4 0 0 0-.4.4.4.4 0 1 0 .8 0 .4.4 0 0 0-.4-.4Zm0 .74a.32.32 0 0 1-.34-.31.32.32 0 0 1 .65-.03.34.34 0 0 1-.3.34Z"
      />
      <path
        fill="url(#i)"
        d="M18.06 12.75a2.75 2.75 0 1 0 5.49 0 2.75 2.75 0 0 0-5.5 0Z"
      />
      <path
        fill="url(#j)"
        d="M18.06 12.75a2.75 2.75 0 1 0 5.49 0 2.75 2.75 0 0 0-5.5 0Z"
      />
      <mask
        id="k"
        width="6"
        height="6"
        x="18"
        y="10"
        maskUnits="userSpaceOnUse"
        style="mask-type:luminance"
      >
        <path
          fill="#fff"
          d="M18.06 12.75a2.74 2.74 0 1 0 5.49 0 2.74 2.74 0 0 0-5.5 0Z"
        />
      </mask>
      <g mask="url(#k)">
        <path
          fill="url(#l)"
          d="M17.75 12.87a3.36 3.36 0 1 0 6.72 0 3.36 3.36 0 0 0-6.72 0Z"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="c"
        x1="22.25"
        x2="19.35"
        y1="15.06"
        y2="10.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F59F00" />
        <stop offset=".19" stop-color="#F49B00" />
        <stop offset=".37" stop-color="#F29101" />
        <stop offset=".5" stop-color="#F08302" />
        <stop offset=".6" stop-color="#EE7905" />
        <stop offset=".76" stop-color="#EC7008" />
        <stop offset="1" stop-color="#EC6D09" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="22.25"
        x2="19.35"
        y1="15.06"
        y2="10.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F3941E" stop-opacity="0" />
        <stop offset=".04" stop-color="#F48C1C" stop-opacity=".08" />
        <stop offset=".2" stop-color="#F77314" stop-opacity=".32" />
        <stop offset=".35" stop-color="#F95D0E" stop-opacity=".53" />
        <stop offset=".5" stop-color="#FB4B09" stop-opacity=".7" />
        <stop offset=".64" stop-color="#FD3D05" stop-opacity=".83" />
        <stop offset=".77" stop-color="#FE3302" stop-opacity=".92" />
        <stop offset=".9" stop-color="#FF2D01" stop-opacity=".98" />
        <stop offset="1" stop-color="#FF2B00" />
      </linearGradient>
      <radialGradient
        id="f"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(4.24 -167.26 291.02) scale(3.3208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F3941E" stop-opacity="0" />
        <stop offset=".45" stop-color="#EA8D1D" stop-opacity=".05" />
        <stop offset=".66" stop-color="#CA7618" stop-opacity=".2" />
        <stop offset=".83" stop-color="#924D10" stop-opacity=".48" />
        <stop offset=".96" stop-color="#441304" stop-opacity=".87" />
        <stop offset=".99" stop-color="#2F0401" stop-opacity=".97" />
      </radialGradient>
      <linearGradient
        id="i"
        x1="22.25"
        x2="19.35"
        y1="15.06"
        y2="10.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F59F00" />
        <stop offset=".19" stop-color="#F49B00" />
        <stop offset=".37" stop-color="#F29101" />
        <stop offset=".5" stop-color="#F08302" />
        <stop offset=".6" stop-color="#EE7905" />
        <stop offset=".76" stop-color="#EC7008" />
        <stop offset="1" stop-color="#EC6D09" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="22.25"
        x2="19.35"
        y1="15.06"
        y2="10.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F3941E" stop-opacity="0" />
        <stop offset=".04" stop-color="#F48C1C" stop-opacity=".08" />
        <stop offset=".2" stop-color="#F77314" stop-opacity=".32" />
        <stop offset=".35" stop-color="#F95D0E" stop-opacity=".53" />
        <stop offset=".5" stop-color="#FB4B09" stop-opacity=".7" />
        <stop offset=".64" stop-color="#FD3D05" stop-opacity=".83" />
        <stop offset=".77" stop-color="#FE3302" stop-opacity=".92" />
        <stop offset=".9" stop-color="#FF2D01" stop-opacity=".98" />
        <stop offset="1" stop-color="#FF2B00" />
      </linearGradient>
      <radialGradient
        id="l"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(4.24 -167.26 291.02) scale(3.3208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#F3941E" stop-opacity="0" />
        <stop offset=".45" stop-color="#EA8D1D" stop-opacity=".05" />
        <stop offset=".66" stop-color="#CA7618" stop-opacity=".2" />
        <stop offset=".83" stop-color="#924D10" stop-opacity=".48" />
        <stop offset=".96" stop-color="#441304" stop-opacity=".87" />
        <stop offset=".99" stop-color="#2F0401" stop-opacity=".97" />
      </radialGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h33v5.55H0z" transform="translate(3.5 10)" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M0 0h33v5.86H0z" transform="translate(3.5 10)" />
      </clipPath>
      <clipPath id="g">
        <path fill="#fff" d="M0 0h33v5.55H0z" transform="translate(3.5 10)" />
      </clipPath>
      <clipPath id="h">
        <path fill="#fff" d="M0 0h33v5.86H0z" transform="translate(3.5 10)" />
      </clipPath>
    </defs>
  </svg>
);

export default DiscoverIcon;
